import { AbstractControl, ValidationErrors } from '@angular/forms';

export class CustomValidators {
  static uppercase(control: AbstractControl): ValidationErrors | null {
    const regex = /^[A-Z]*$/g;
    const uppercase = regex.test(control.value);
    return uppercase ? null : ({ uppercase: 'application id should be in uppercase' } as ValidationErrors);
  }
}
